'use client';
var ACCORDION_ERRORS_ITEM_CONTEXT = "Компонент Accordion.Item не найден в дереве";

export { ACCORDION_ERRORS_ITEM_CONTEXT };
